import Header from "@/components/Header";
import { Footer2 } from "@/components/ui/shadcnblocks-com-footer2";
import PageTransition from "@/components/PageTransition";
import { SEO } from "@/components/SEO";

const Returns = () => {
  return (
    <PageTransition>
      <SEO
        title="מדיניות החזרות וביטולים"
        description="מדיניות החזרות וביטולים של אליס תכשיטים - תנאי ביטול עסקה, החלפת תכשיטים, אחריות ותנאים מיוחדים"
        canonical="https://alice.jewelry/returns"
        breadcrumbs={[
          { name: 'דף הבית', url: '/' },
          { name: 'מדיניות החזרות', url: '/returns' },
        ]}
      />
      <div className="min-h-screen flex flex-col" dir="rtl">
        <Header />
        
        <main className="flex-1">
          <section className="py-16 px-4">
            <div className="container mx-auto max-w-4xl">
              <div className="text-center mb-12 animate-fade-in">
                <div className="gold-divider mb-6" />
                <h1 className="text-4xl md:text-5xl font-serif mb-4">מדיניות החזרות וביטולים</h1>
                <p className="text-lg text-muted-foreground">ביטול עסקה בהתאם לחוק להגנת הצרכן התשמ"א 1981- ומדיניות החזרת מוצרים</p>
              </div>

              <div className="space-y-6 text-right animate-fade-in" style={{ animationDelay: '0.1s' }}>
                <div>
                  <h2 className="text-2xl font-serif mb-3">החזרת התכשיט וביטול העסקה</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    החזרת התכשיט וביטול העסקה בצירוף חשבונית ותעודת אחריות עד יומיים מיום הקניה.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold mb-2">עסקאות עד 3,000 ש"ח</h3>
                  <p className="text-muted-foreground leading-relaxed">
                    עסקה לרכישת תכשיט, שמחירו לא עולה על 3,000 ש"ח, ניתן לבטל מיום הרכישה ועד תום יומיים שלאחריו (שאינם ימי מנוחה).
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold mb-2">עסקאות מעל 3,000 ש"ח</h3>
                  <p className="text-muted-foreground leading-relaxed">
                    מעל סכום 3,000 ש"ח יינתן זיכוי בלבד תמורת החזרת התכשיט בתוך יומיים מיום הקניה בהתאם לחוק הגנת הצרכן.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold mb-2">מועד אחרון לביטול העסקה</h3>
                  <p className="text-muted-foreground leading-relaxed">
                    ניתן לבטל את העסקה מיום הרכישה ועד תום שני ימים שלאחריו שאינם ימי מנוחה.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold mb-2">דמי ביטול עקב חרטה</h3>
                  <p className="text-muted-foreground leading-relaxed">
                    5% או 100 ₪ הנמוך מבניהם.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-semibold mb-2">החלפת התכשיט</h3>
                  <p className="text-muted-foreground leading-relaxed">
                    החלפת התכשיט בצירוף חשבונית ותעודת אחריות עד 14 ימים מיום הקנייה (לא כולל ימי מנוחה).
                  </p>
                </div>

                <div className="bg-muted/30 p-6 rounded-lg">
                  <h3 className="text-xl font-semibold mb-3">תנאים מיוחדים</h3>
                  <ul className="space-y-2 text-muted-foreground">
                    <li>• ביטול עסקה לא יחולו על תכשיט בהזמנה אישית/מיוחדת שיוצרו במיוחד עבור הצרכן ולא יתקבל זיכוי כספי.</li>
                    <li>• תכשיטים שיצורו בעיצוב אישי או שינוי בתכשיט הקיים במלאי עבור הלקוח לא יינתן זיכוי/החזר כספי.</li>
                    <li>• דמי משלוח עבור החזרת תכשיט/שעון יחולו על הצרכן בלבד.</li>
                    <li>• לתכשיט תוצמד טיקט, הורדת הטיקט תבטל החזר כספי ותזכה בזיכוי להחלפת מוצר בלבד עד 14 יום ממועד הרכישה.</li>
                    <li>• אין החברה אחראית על אובדן / נזק ליהלום מרכזי בתכשיט יהלומים (מומלץ לעשות ביטוח).</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-semibold mb-2">אחריות</h3>
                  <p className="text-muted-foreground leading-relaxed">
                    אחריות על התכשיט שנה מיום הקנייה. אין האחריות תקפה אם נעשה שימוש לא ראוי בתכשיט בכל דרך שהיא.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer2 />
      </div>
    </PageTransition>
  );
};

export default Returns;
